module.exports = __webpack_public_path__ + "img/mes-scene-assembly.b77f2fd9.jpg";